module.exports = __webpack_public_path__ + "img/attachicon.d1302458.svg";